const showColors = document.getElementsByClassName("col-swatch");
const swatchesColors = document.getElementsByClassName("swatches__container");

const colors = {
  clear: "#",
  "multi-pastello": "*",
  "multi-estivo": "*",
  arcobaleno: "*",
  "multi-invernale": "*",
  arancione: "#D7602C",
  ruggine: "#BD4415",
  "lt.smoked-topaz": "#BD4415",
  arancio: "#D7602C",
  hyacint: "#D7602C",
  rodio: "#A7A3A7",
  "metallizzato-2-toni": "#A7A3A7",
  beige: "#F5F5DC",
  "lt.colorado-topaz": "#F5D4B8",
  "perla-crema": "#E6E1D4",
  "perla-bianco": "#E6E2DE",
  bianco: "#FEFEFB",
  cristallo: "#FEFEFB",
  "blue-marine": "#00355F",
  "blu-marine": "#00355F",
  marine: "#00355F",
  azzurro: "#86C4EC",
  "lt.sapphire": "#86C4EC",
  "blu-royal": "#005A90",
  ottanio: "#00546C",
  "blu-ottanio": "#00546C",
  cardinale: "#C10735",
  montana: "#00355F",
  "multi-naturale": "#792B17",
  royal: "#005A90",
  sapphire: "#005A90",
  marrone: "#792D05",
  "smoked-topaz": "#792D05",
  taupe: "#BEA48C",
  ocra: "#CF9328",
  "giallo-ocra": "#CF9328",
  giallino: "#FFD740",
  giallo: "#FFD740",
  jonquil: "#FFD740",
  topaz: "#CF9328",
  grigio: "#B2B2B2",
  "black-diamond": "#B2B2B2",
  black: "#1D1D1B",
  ematite: "#1D1D1B",
  nero: "#1D1D1B",
  jet: "#1D1D1B",
  "bianco-nero": "#1D1D1B",
  oro: "#C49739",
  "oro-rosa": "#E9506B",
  "metallizzato-3-toni": "#CB9984",
  rosa: "#E9506B",
  rose: "#E9506B",
  avorio: "#F9EBDB",
  pesca: "#F08969",
  salmone: "#F08969",
  rosso: "#BE1319",
  corallo: "#D74335",
  "lt.siam": "#D74335",
  rosaantico: "#E4A8AA",
  "rosa-antico": "#E4A8AA",
  bordeaux: "#780E16",
  garnet: "#780E16",
  "turchese-chiaro": "#8FBAB6",
  acqua: "#66B1AB",
  acquamarina: "#66B1AB",
  verde: "#456630",
  "verde-fluo": "#6EB52C",
  "verde-lime": "#CCCC3C",
  peridot: "#CCCC3C",
  verdone: "#4F680E",
  emerald: "#4F680E",
  oliva: "#616E03",
  cacky: "#A4934E",
  olivine: "#616E03",
  turchese: "#1DAF95",
  lilla: "#B791B6",
  "lt.amethisth": "#B791B6",
  viola: "#6B3E90",
  amethisth: "#6B3E90",
  "viola-scuro": "#4E0E50",
  grezzo: "#D0B98F",
  fuxia: "#C00059",
  fucshia: "#C00059",
  petrolio: "#006271",
  senape: "#E3A722",
  "fuxia-fluo": "#D10073",
  "arancio-fluo": "#E74620",
  "giallo-fluo": "#FFE000",
  "marrone-medio": "#965926",
  "blu-elettrico": "#004383",
};

function changeColor() {
  if (showColors.length > 0) {
    for (let showColor of showColors) {
      const lis = showColor.getElementsByTagName("li");

      for (let li of lis) {
        // classList contains always 2 classes
        // In the first place will be always 'color'
        // The second one defines the color and is the one we should looking for
        const classList = li.classList;
        const color = classList.value.split(" ")[1];

        const span = li.getElementsByTagName("span")[0];
        span.style["background-color"] = colors[color];
      }
    }
  }

  if (swatchesColors.length > 0) {
    for (let swatchColor of swatchesColors) {
      const labels = swatchColor.getElementsByTagName("label");

      for (let label of labels) {
        const hasColorBackground = label.getAttribute("style");

        if (hasColorBackground) {
          const color = hasColorBackground
            .split("background-color:")[1]
            .split(";")[0];

          label.style.backgroundColor = colors[color.trim()];
        }
      }
    }
  }

  const filterLabels = document.querySelectorAll(".color-filter-label");
  filterLabels.forEach((filterLabel) => {
    const color = filterLabel.getAttribute("color");
    filterLabel.style.backgroundColor = colors[color];
  });
}

changeColor();
/*
const isInfinite = document.getElementsByClassName("is_infinite");

function checkDOMChange() {
  // check for any new element being inserted here,
  // or a particular node being modified
  changeColor();
  // call the function again after 100 milliseconds
  setTimeout(checkDOMChange, 500);
}

if (isInfinite.length > 0) {
  checkDOMChange();
}

const headerIsHover = document.getElementsByClassName("nav-container grid__wrapper full above logo-center")[0];

if (headerIsHover) {
  const firstLink = headerIsHover.querySelector(".first_logo_link")
  const secondLink = headerIsHover.querySelector(".second_logo_link")
  
  headerIsHover.addEventListener("mouseenter", () => {
    firstLink.style.display = 'none';
    secondLink.style.display = 'block';
  })
  
  headerIsHover.addEventListener("mouseleave", () => {
    firstLink.style.display = 'block';
    secondLink.style.display = 'none';
  })
}
*/